import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import * as types from 'misc/types';
import SideMenu from '../shared/sidemenu/SideMenu';
import InboxListItem from '../inbox/InboxListItem';
import TagFolder from '../archives/TagFolder';
import SearchField from '../archives/SearchField';
import { getText, trackGA } from 'misc/helpers';
import EnvelopeView from './inbox/EnvelopeView';

class Archives extends Component {
    constructor(props) {
        super(props);

        const { dispatch, sessions } = this.props;

        this.state = {
            tab: 1
        };

        // Fetch tags
        dispatch({ type: types.SAGA_TAGS_GET.REQUEST, customerId: sessions.data.customerId });

        dispatch({ type: types.ARCHIVES_SEARCH_CLEAR });
    }

    render = () => {
        const { search_results, tags } = this.props;

        // Filter tags with no envelopes and right category
        let filteredTags = [];

        if (tags.data) {
            if (this.state.tab === 1) {
                filteredTags = tags.data.filter(tag => tag.type === 1 && tag.count > 0);
            } else {
                filteredTags = tags.data.filter(tag => (tag.type === 2 || tag.type === 3) && tag.count > 0);
            }
        }

        // Fix their order nr so colors are correct
        let i = 0;
        filteredTags.forEach(function(tag) {
            tag.order = i;
            i++;
        });

        // Only show results that have not been deleted
        let nrSearchResults = 0;

        if (search_results.data && search_results.data.results) {
            search_results.data.results.forEach(function(result) {
                if (!result.hide) {
                    nrSearchResults++;
                }
            });
        }

        return (
            <div className="main-content">
                <SideMenu />
                <article className="list-content archives animation-fade-in">
                    <div className="padded-content">
                        <SearchField />

                        {search_results.data && (search_results.data.filterTag || search_results.data.searchTerm) ? (
                            <React.Fragment>
                                <h2>
                                    {nrSearchResults} {getText('Missing', 'träffar')}
                                </h2>
                                <ul>
                                    {search_results.data.results.map(envelope => (
                                        <InboxListItem view="archives" className={envelope.state.archived ? 'hej' : ''} {...envelope} />
                                    ))}
                                </ul>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="archives-tabs">
                                    <div
                                        onClick={() => this.changeTab(1)}
                                        className={this.state.tab === 1 ? 'archive-tab active' : 'archive-tab'}
                                    >
                                        <span>{getText('_3_1_category', 'Kategori')}</span>
                                    </div>
                                    <div
                                        onClick={() => this.changeTab(2)}
                                        className={this.state.tab === 2 ? 'archive-tab active' : 'archive-tab'}
                                    >
                                        <span>{getText('_3_1_timeofarrival', 'Tidpunkt')}</span>
                                    </div>
                                </div>
                                <div className="folders">
                                    {filteredTags.map(tag => <TagFolder onClick={() => this.selectTag(tag)} {...tag} />)}
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </article>
                <aside className="view-content animation-fade-in">
                    <Route path="/archives/:id" component={EnvelopeView} />
                </aside>
            </div>
        );
    };

    changeTab(type) {
        this.setState({
            tab: type
        });
    }

    selectTag(tag) {
        const { dispatch, sessions, search_results } = this.props;
        dispatch({
            type: types.SAGA_ARCHIVES_SEARCH_GET.REQUEST,
            customerId: sessions.data.customerId,
            searchTerm: search_results.searchTerm,
            filterTag: tag
        });
    }

    componentDidMount() {
        // Get envelopes
        const { customer, dispatch } = this.props;
        dispatch({ type: types.SAGA_ENVELOPES_ARCHIVES_GET.REQUEST, customer: customer.data, tagged: '_ARCHIVED' });

        trackGA('3.1 Arkiv');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions,
        tags: state.tags,
        customer: state.customer,
        search_results: state.search_results
    };
};

export default connect(mapStateToProps)(Archives);



// WEBPACK FOOTER //
// ./src/components/views/Archives.js